import * as template from './searchByIssue.hbs';
import Component from '../component/component';
import { busy, ready } from '../animations/busy';
import { PublicationTypes, MarkedNumber } from './model';
import Result from './result';
import * as queryString from 'query-string';
import TidingsClient from './tidingsClient';

class ViewModel {

    publicationTypes = PublicationTypes;
    publicationType: string = '';
    years: MarkedNumber[] = [];
    year: number = 0;
    issues: MarkedNumber[] = [];
    issue: number = 0;
    initializing: boolean = false;
}

export default class SearchByIssue extends Component<ViewModel> {
    private _tidingsClient: TidingsClient;

    constructor(private result: Result) {
        super(template, new ViewModel());

        this._tidingsClient = new TidingsClient();

        this.initializeModelFromSearch();
    }

    protected bind(element: Element, viewModel: ViewModel) {

        let publicationTypes = <HTMLElement>element.querySelector('#publicationTypes');
        let years = <HTMLElement>element.querySelector('#years');
        let issues = <HTMLElement>element.querySelector('#issues');
        if (publicationTypes) {
            publicationTypes.addEventListener('change', async e => (await this.publicationTypeSelected(<HTMLElement>e.currentTarget)));
        }
        if (years) {
            years.addEventListener('change', async e => (await this.yearSelected(<HTMLElement>e.currentTarget)));
        }
        if (issues) {
            issues.addEventListener('change', async e => (await this.issueSelected(<HTMLElement>e.currentTarget)));
        }
    }

    private async initializeModelFromSearch() {

        let search = queryString.parse(window.location.search);
        let hash = window.location.hash;

        if (search.publicationType && this.viewModel.publicationTypes.hasOwnProperty(search.publicationType)) {
            this.viewModel.publicationType = search.publicationType;
            this.viewModel.initializing = true;

            await this.publicationTypeSelected();

            let year = parseInt(search.year);
            if (year && this.exists(year, this.viewModel.years)) {
                this.viewModel.year = year;

                await this.yearSelected();

                let issue = parseInt(search.issue);
                if (issue && this.exists(issue, this.viewModel.issues)) {
                    this.viewModel.issue = issue;

                    this.viewModel.initializing = false;
                    this.refresh();
                    await this.issueSelected();

                    window.setTimeout(()=>window.location.hash = hash, 100);
                    return;
                }
            }

            this.viewModel.initializing = false;
            this.refresh();
        }
    }

    private exists(year: number, numbers: MarkedNumber[]): boolean {
        for (let n of numbers) {
            if (n.number === year) return true;
        }
        return false;
    }    

    private async publicationTypeSelected(element?: HTMLElement): Promise<SearchByIssue> {
        let indicator = <HTMLElement>document.querySelector('.busy-indicator');
        busy(indicator);
        this.viewModel.publicationType = element ? (<HTMLInputElement>element).value : this.viewModel.publicationType;
        this.viewModel.years = await this._tidingsClient.getYearsByPublicationType(this.viewModel.publicationType);
        this.viewModel.year = 0;
        ready(indicator);
        this.setUrl();
        this.refresh();

        return Promise.resolve(this);
    }

    private async yearSelected(element?: HTMLElement): Promise<SearchByIssue> {
        let indicator = <HTMLElement>document.querySelector('.busy-indicator');
        busy(indicator);
        this.viewModel.year = element ? parseInt((<HTMLInputElement>element).value) : this.viewModel.year;
        this.viewModel.issues = await this._tidingsClient.getIssuesByPublicationTypeAndYear(this.viewModel.publicationType, this.viewModel.year);
        this.viewModel.issue = 0;
        ready(indicator);
        this.setUrl();
        this.refresh();

        return Promise.resolve(this);
    }

    private async issueSelected(element?: HTMLElement): Promise<SearchByIssue> {
        let indicator = <HTMLElement>document.querySelector('.busy-indicator');
        busy(indicator);
        this.viewModel.issue = element ? parseInt((<HTMLInputElement>element).value) : this.viewModel.issue;

        let headers = await this._tidingsClient.getPublicationsByPublicationTypeYearAndIssue(this.viewModel.publicationType, this.viewModel.year, this.viewModel.issue);

        if (headers.length === 0) {
            let batches = await this._tidingsClient.getBatchByPublicationTypeYearAndIssue(this.viewModel.publicationType, this.viewModel.year, this.viewModel.issue);
            if (batches.length === 1) {
                this.result.showBatch(batches[0]);
            }
        }
        else {
            this.result.showPublications(headers);
        }
        let expander = <HTMLElement>document.querySelector('.expandcodes');
        let codes = <HTMLElement>document.querySelector('.publicationcodes');
        if (expander && codes) {
            expander.addEventListener('click', e => {
                e.preventDefault();
                codes.style.display = codes.style.display === 'block' ? 'none' : 'block';
            });
        }

        this.setUrl();
        window.scrollTo(0, 0);

        ready(indicator);
        return Promise.resolve(this);
    }

    private setUrl() {
        let newUrl = window.location.href.split('?')[0];
        if (this.viewModel.publicationType) {
            newUrl += '?publicationType=' + this.viewModel.publicationType;

            if (this.viewModel.year) {
                newUrl += '&year=' + this.viewModel.year;

                if (this.viewModel.issue) {
                    newUrl += '&issue=' + this.viewModel.issue;
                }
            }

            window.history.replaceState('', this.viewModel.publicationType + 'Tidende', newUrl);
        }
    }

}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./Frontend/src/Tidings/searchByIssue.ts